const top = (() => {
  const pageTop = (document.getElementById("pageTop") != null);

  if (pageTop) {


    console.log('top');
    // document.addEventListener("DOMContentLoaded", () => {
    window.addEventListener('load', (event) => {

      var urlParam = location.search.substring(1);
      if (urlParam) {
        var param = urlParam.split('&');

        var paramArray = [];

        for (let i = 0; i < param.length; i++) {
          var paramItem = param[i].split('=');
          paramArray[paramItem[0]] = paramItem[1];
        }


        if (paramArray.id == 'bk') {
          document.querySelector('body')?.classList.remove('wh');
          document.querySelector('body')?.classList.add('bk');
        };
        if (paramArray.id == 'wh') {
          document.querySelector('body')?.classList.remove('bk');
          document.querySelector('body')?.classList.add('wh');
        };
      };

      if (window.matchMedia('(max-width: 769px)').matches) {
        var topPlxSpeed1 = -2;
        var topPlxSpeed2 = -1;

        var rellax_cntSpeed1 = 1;
        var rellax_cntSpeed2 = 2;

        var rellax_cntSpeed_m1 = -1;
        var rellax_cntSpeed_m2 = -1;
      } else {
        var topPlxSpeed1 = -4;
        var topPlxSpeed2 = -2;

        var rellax_cntSpeed1 = 2;
        var rellax_cntSpeed2 = 3;

        var rellax_cntSpeed_m1 = -2;
        var rellax_cntSpeed_m2 = -4;
      }
      var rellax_1 = new Rellax('.topRellax_1', {
        speed: topPlxSpeed1,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      });
      var rellax_2 = new Rellax('.topRellax_2', {
        speed: topPlxSpeed2,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      });


      var rellax_cnt = new Rellax('.rellax_cnt', {
        speed: rellax_cntSpeed1,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      });
      var rellax_cnt2 = new Rellax('.rellax_cnt2', {
        speed: rellax_cntSpeed2,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      });

      var rellax_cnt_m = new Rellax('.rellax_cnt_m', {
        speed: rellax_cntSpeed_m1,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      });
      var rellax_cnt_m2 = new Rellax('.rellax_cnt_m2', {
        speed: rellax_cntSpeed_m2,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      });
    });
  }
})();
export default top;